import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchTournaments, fetchPlayers, fetchTeams } from '../actions';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

class FieldTournamentId extends Component {
    state = {
        ttId: new URL(location.href).searchParams.get('ttId') || localStorage.getItem('ttId') || ''
    };

    componentDidMount() {
        this.props.fetchTournaments();
        this.loadData(this.state.ttId);
    }

    loadData = (ttId = '') => {
        if (ttId) {
            const { fetchPlayers, fetchTeams } = this.props;

            fetchPlayers(ttId);
            fetchTeams(ttId);
            localStorage.setItem('ttId', ttId);
            const idLineUp = new URL(location.href).searchParams.get('idLineUp');
            history.pushState({}, '', `?ttId=${ttId}${idLineUp ? `&idLineUp=${idLineUp}` : ''}`);
        }
    };

    handleChange = (ev, index, ttId = '') => {
        ev.preventDefault();
        this.loadData(ttId);
        this.setState({ ttId });
    };

    render() {
        const { tournamentsList = [], tournaments = {} } = this.props;
        const { ttId = '' } = this.state;

        return (
            <SelectField
                floatingLabelText="Tournament"
                value={parseInt(ttId, 10)}
                onChange={this.handleChange}
                fullWidth
            >
                {tournamentsList.map(id => (
                    <MenuItem
                        key={id}
                        value={id}
                        primaryText={tournaments[id] && `${tournaments[id].countryName} | ${tournaments[id].name}`}
                    />
                ))}
            </SelectField>
        );
    }
}

FieldTournamentId.propTypes = {
    // From connect
    tournaments: PropTypes.object,
    tournamentsList: PropTypes.arrayOf(PropTypes.number.isRequired),
    fetchTournaments: PropTypes.func.isRequired,
    fetchPlayers: PropTypes.func.isRequired,
    fetchTeams: PropTypes.func.isRequired
};

export default connect(
    ({ requery = { entities: {}, list: {} } }) => ({
        tournaments: requery.entities && requery.entities.tournaments,
        tournamentsList: requery.list.tournaments
    }),
    { fetchTournaments, fetchPlayers, fetchTeams }
)(FieldTournamentId);



/** WEBPACK FOOTER **
 ** ../src/dash/front/grid-maker-tool-page/components/FieldTournamentId.js
 **/